const actions = {
    FETCH_STUDENT_CLUB_MEMBERSHIPS: 'FETCH_STUDENT_CLUB_MEMBERSHIPS',
    FETCH_STUDENT_CLUB_MEMBERSHIP: 'FETCH_STUDENT_CLUB_MEMBERSHIP',
    RESET_STUDENT_CLUB_MEMBERSHIP: 'RESET_STUDENT_CLUB_MEMBERSHIP',

    fetchStudentClubMembershipsAction: (data) => {
        return {
            type: actions.FETCH_STUDENT_CLUB_MEMBERSHIPS,
            data: data
        };
    },
    resetStudentClubMembershipFormAction: () => {
        return {
            type: actions.RESET_STUDENT_CLUB_MEMBERSHIP,
            data: null
        };
    },
    fetchStudentClubMembershipAction: (data) => {
        return {
            type: actions.FETCH_STUDENT_CLUB_MEMBERSHIP,
            data: data
        };
    },
};

export default actions;